Object.defineProperty(exports, "__esModule", { value: true });
var perimeterPoints_1 = require("./perimeterPoints");
function getSortedSegments(pathSegments) {
    return pathSegments
        .map(function (points) { return ({
        points: points,
        perimeter: perimeterPoints_1.perimeterPoints(points)
    }); })
        .sort(function (a, b) { return b.perimeter - a.perimeter; })
        .map(function (a) { return a.points; });
}
exports.getSortedSegments = getSortedSegments;
